import { render, staticRenderFns } from "./questionBankOrderList.vue?vue&type=template&id=2ce45f58&scoped=true"
import script from "./questionBankOrderList.vue?vue&type=script&lang=js"
export * from "./questionBankOrderList.vue?vue&type=script&lang=js"
import style0 from "./questionBankOrderList.vue?vue&type=style&index=0&id=2ce45f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce45f58",
  null
  
)

export default component.exports